var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 15.75V17.625C14.75 18.1223 14.5525 18.5992 14.2008 18.9508C13.8492 19.3025 13.3723 19.5 12.875 19.5H5.375C4.87772 19.5 4.40081 19.3025 4.04917 18.9508C3.69754 18.5992 3.5 18.1223 3.5 17.625V6.375C3.5 5.87772 3.69754 5.40081 4.04917 5.04917C4.40081 4.69754 4.87772 4.5 5.375 4.5H12.5C13.5355 4.5 14.75 5.33953 14.75 6.375V8.25M17.75 15.75L21.5 12L17.75 8.25M8.75 12H20.75",
    stroke: "#505762",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8da9ff796de6624de2d6548354b5f549.svg";
export { ForwardRef as ReactComponent };